export enum MDSRowItemSlotName {
  LeftAddon = "left-addon",
  RightAddon = "right-addon",
  LastAddon = "last-addon",
  BottomAddon = "bottom-addon",
}

export enum MDSRowItemSize {
  Medium = "Medium",
  Large = "Large",
  XLarge = "XLarge",
  Full = "Full",
}

export interface MDSRowItemProps extends React.HTMLAttributes<HTMLDivElement> {
  noSeparator?: boolean;
  $hasSuggestion: boolean | undefined;
  $mustClickOnRowTitle: boolean;
  $isSelected: boolean | undefined;
  $isHighlighted: boolean | undefined;
  $isSpecial: boolean | undefined;
  $size: MDSRowItemSize;
}
